import { Injectable, Inject, Input, Directive } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BackendService } from 'app/services/backend.service';
import { Observable } from 'rxjs';
import { SvcServices, PopupModalService, SiteCatalystService, ContentService } from '../../../services';
import { Subject } from 'rxjs';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { ActivatedRoute, Params } from '@angular/router';

declare let assertion: any;
declare let CryptoJS: any;
declare let $: any;
declare let koreBotChat: any;
declare let koreBotCloudChat: any;


@Directive()
@Injectable()
export class ChatbotService {
  @Input()
  userActivity;
  popupContentComponent: any = "";
  dataLayer: any;
  userInactive: Subject<any> = new Subject();
  koreBot: any;
  pageData: any;
  data: any;
  endpoint: string;
  httpMethod: string;
  jwtResponse: any;
  globalData: any;
  taskBotEnv: any;
  KoreBotMessageURl: any;
  brandId: any = "";
 
  constructor(public backend: BackendService,
    private _svcService: SvcServices,
    private popupModalService: PopupModalService,
    private scService: SiteCatalystService,
    private _contentService: ContentService,
    public _appConfigService: AppConfigService,
    private _route: ActivatedRoute) {


    console.log('#Chatbot - chatbot.service constructor');

    this._route.queryParams.subscribe((qParam: Params) => {
      if (Object.keys(qParam).length > 0) {
        if (qParam.brandId)
          this.brandId = qParam.brandId.toLowerCase();
      }
    });
  }

  addListenerMulti(element, eventNames, listener) {
    console.log("Listener Multi");
    var events = eventNames.split(' ');
    for (var i = 0, iLen = events.length; i < iLen; i++) {
      element.addEventListener(events[i], listener, false);
    }
  }
  listenEvent() {
    console.log("Listen Event");
    this.addListenerMulti(window, 'tap mouseup mousedown keyup keydown', () => {
      clearTimeout(this.userActivity);
      this.setTimer();
    });
  }
  setTimer() {
    console.log("Set Timer");
    this.userActivity = setTimeout(() => this.userInactive.next(undefined), (90 * 1000));
  }
  eventFunc() {
    console.log("Event Function");
    () => {
      clearTimeout(this.userActivity);
      this.setTimer();
    }
  }


  openProactiveChat() {
    console.log("Open Proactive Chat");
    if ((!sessionStorage.getItem("proactive_chat")) && (!sessionStorage.getItem("ChatbotIsOpened"))) {
      this.popupModalService.openPopupContent.emit({
        popupContentComponent: 'popup-site-proactive-chat',
      });
      this.popupModalService.setElementStyle.emit("visible");
      let eventObject = {
        minorInteraction: "cova_chat_offer",
        module: "cova_proactive",
        view: "index"
      }
      this.scService.setSCPageData("customMinorInteraction",null,eventObject);
      sessionStorage.setItem("proactive_chat", "YES");
    }
  }

  

  koreServiceJwtApiCall() {
    console.log("Kore Service JWT API Call");
    this.data = {
      "botInfo": {
        'chatBot': "COVA",
        'cloudBotId': this._svcService. getcloudBotId()
      }
    };
    // let subscription = this._svcService.globalContent.subscribe((data) => {
    //   if (data !== null && data !== undefined) {
    //     this.globalData = data;
    //   }
    // });
    // subscription.unsubscribe();
    this.endpoint = 'preLoginKoreTokenUrlCloud';
    this.httpMethod = 'get';
    var config = this._appConfigService.getConfig("api");
    var serverClientId = config.headers.client_id;
    var headers = {
      'siteId': this._svcService.pData.siteId.toUpperCase(),
      'client_id': serverClientId,
      'subBrandId': this.brandId.toUpperCase()
    };
    console.log("botinfo: " + this.data);
      headers['EnvironmentId' ] ='FSVCKORE'
      return this.backend.get(this.endpoint, this.data, headers);
  }

  assertion(options, callback) {
    console.log("Assertion");
    if (options.koreJWTGrant) {
      callback(null, options);
    } else {
      console.log("ERROR: status code ");
    }
  }

  koreGenerateUUID() {
    console.log("Kore Generate UUID");
    let d = new Date().getTime();
    if(window.performance && typeof window.performance.now === "function") {
      d += performance.now();
    }
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      let r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

  sendAjaxDestroy() {
    console.log("Send Ajax Destroy");
    try {
      if (sessionStorage.getItem("koreJwtToken") != null) {
        let koreJwtTokenResponse = JSON.parse(sessionStorage.getItem("koreJwtToken"));
        let randomNum = this.koreGenerateUUID();
        let token = koreJwtTokenResponse.ssgAuthorization.access_token;
        let koreToken = koreJwtTokenResponse.authorization.accessToken;
        let url = this.KoreBotMessageURl;
        $.ajax({
          type: 'POST',
          url: 'https://' + url + '/api/1.1/oAuth/signout?rnd=' + randomNum + '&Auth=' + token,
          data: {},
          beforeSend: function (xhr) {
            xhr.setRequestHeader('x-http-method-override', 'delete');
            xhr.setRequestHeader('content-type', 'application/json');
            xhr.setRequestHeader('Kore_Authorization', 'Bearer ' + koreToken);
          },
          async: false,
          success: function (result) {
            console.log('ajax success');
          },
          complete: function (response) {
            console.log('ajax complete');
          }
        });
      }
    } catch (err) {
      console.log(err);
    }
  }

  chatBotDestroy() {
    console.log("Chatbot Destroy");
    try{
    if(this.koreBot){
      this.koreBot.destroy();
    }
    sessionStorage.removeItem("welcomeIndicator");
    sessionStorage.removeItem("messageId");
    sessionStorage.removeItem("chatBotIsOpened");
    if(sessionStorage.getItem("accountErrorSent")){
      sessionStorage.removeItem("accountErrorSent");
    }
    if(sessionStorage.getItem("botError")){
      sessionStorage.removeItem("botError");
    }
    sessionStorage.removeItem("actionPromptEnabled");
    this.sendAjaxDestroy();
    sessionStorage.removeItem("koreJwtToken");
    }catch(err){
      console.log(err);
    }
  }

  sendCustomMessage(botError) {
    console.log("Send Custom Message");
    if (sessionStorage.getItem("chatBotIsOpened") == 'YES') {
      var errorString;
      if(botError.errorType=="GPUERROR"){
        errorString = botError.errorType+" "+botError.httpCode+" "+botError.errorDetail;
      }
      else{
        errorString = botError.errorType+" "+botError.errorCode;
      }
      this.koreBot.sendCustomMessage(errorString);
      console.log("Error code sent to Kore: "+ errorString);
      sessionStorage.removeItem("botError");
    }
  }

  public showBot() {
    console.log("Show Bot");
    try {
      this.koreBot = koreBotCloudChat();
    } catch (err){
      console.log('#Chatbot - showBot() error');
      console.log(err);
    }

    this._contentService.module_content.subscribe((data) => {
      if (data !== null && data !== undefined) {
        if((data.content && data.content.CARDS) || (data.value)){
        this.pageData = (data.value) ? data.value.content.CARDS : data.content.CARDS;
        }
      }
    });

    this.KoreBotMessageURl = this._svcService.getkoreWebSocketCloudUrl();
    sessionStorage.setItem("KoreBotMessageURl", this.KoreBotMessageURl);
    this.taskBotEnv = this._svcService.getcloudBotId();
    sessionStorage.setItem("taskBotEnv", this.taskBotEnv);
    sessionStorage.setItem("botName", "test");
    this.jwtResponse = null;
    this.koreServiceJwtApiCall().subscribe((response) => {
    this.initiateWebSocket(response.body);
      });
    
  }


  initiateWebSocket(response) {
    console.log("Initiate Web Socket");
    //console.log("response from API:" + JSON.stringify(response));
      this.jwtResponse = response;
      window["jwtResponse"] = this.jwtResponse;
      let botOptions: any = {};
      botOptions.logLevel = 'debug';
      botOptions.method = 'POST';
      const token = this.jwtResponse.jwt;
      botOptions.koreAPIUrl = 'https://' + this.KoreBotMessageURl + '/api/rtm/start?Auth='+ token;
      botOptions.recorderWorkerPath = '../libs/recorderWorker.js';
      botOptions.assertionFn = ((options, callback) => { this.assertion(options, callback) });
      let temp = this.jwtResponse;
      botOptions.koreJWTGrant = function () {
        return temp;
      }.bind(this);

      //default if CMS content is missing
      var botInfoName = 'Hello<span>.</span>';;
      var botInfoProductName = 'Credit Card';
      var actionPrompt = false;

      if (this.pageData
      && this.pageData.config$$rule_partner_catalog_contact_us){
          var ruleResponses = this.pageData.config$$rule_partner_catalog_contact_us.ruleResponse;
          var ruleResponse = ruleResponses[0];

          if (this.brandId) {
            var index = ruleResponses.findIndex((item:string) => item && item.toLowerCase() === `cfg_catalog_${this.brandId}`);
            ruleResponse = ruleResponses[index] || ruleResponse;
          }

          var configCatalogId = 'config$$' + ruleResponse;
          var catalogContent = this.pageData[configCatalogId];
          if(catalogContent){
            botInfoName = catalogContent.chatbot_header;
            botInfoProductName = catalogContent.card_program_name;
          } else {
            console.log('Cova partner CMS catalog is missing');
          }
      } else {
        console.log('Cova partner CMS rule response is missing');
      }

      if(this.pageData &&
        this.pageData.config$$cfg_cw_app_client_settings.emergency_message_cova_partners.includes(this._svcService.getSiteId())){
          actionPrompt = true;
          sessionStorage.setItem("actionPromptEnabled","true");
        }

      botOptions.botInfo = {
        name: botInfoName,
        customData: {
          JWEToken: token,
          productName: botInfoProductName,
          actionPrompt: actionPrompt
        },
        _id: this._svcService.getTaskBotId(),
        tenanturl: {}
      };

      let chatConfig = {
        'botOptions': botOptions,
        'allowIframe': false,
        'isSendButton': true,
        'isTTSEnabled': false,
        'isSpeechEnabled': false,
        'allowGoogleSpeech': false,
        'allowLocation': false,
        'loadHistory': false,
        'messageHistoryLimit': 10,
        'autoEnableSpeechAndTTS': false,
        'graphLib': 'd3'
      };
      ($('[data-module="cova_reactive"]').hide());
      chatConfig.botOptions['chatHistory'] = this.koreBot.chatHistory;
      this.koreBot.show(chatConfig);
      sessionStorage.setItem("chatBotIsOpened", "YES");
    }

  }

